import { useState } from 'react';

export default function UrlEncoder() {
    const [input, setInput] = useState('');
    const [encoded, setEncoded] = useState('');
    const [decoded, setDecoded] = useState('');

    const encode = () => {
        try {
            const result = encodeURIComponent(input);
            setEncoded(result);
        } catch (e) {
            setEncoded('Error encoding');
        }
    };

    const decode = () => {
        try {
            const result = decodeURIComponent(input);
            setDecoded(result);
        } catch (e) {
            setDecoded('Error decoding - invalid URL encoding');
        }
    };

    const encodeUrl = () => {
        try {
            const result = encodeURI(input);
            setEncoded(result);
        } catch (e) {
            setEncoded('Error encoding');
        }
    };

    const copyToClipboard = async (text: string) => {
        try {
            await navigator.clipboard.writeText(text);
            alert('Copied to clipboard!');
        } catch (e) {
            alert('Failed to copy');
        }
    };

    const clearAll = () => {
        setInput('');
        setEncoded('');
        setDecoded('');
    };

    return (
        <div className="max-w-4xl mx-auto">
            <h1 className="text-3xl font-bold mb-2">URL Encoder/Decoder</h1>
            <p className="text-gray-600 mb-6">Encode and decode URL strings</p>

            <div className="space-y-6">
                <div className="tool-card">
                    <div className="flex justify-between items-center mb-2">
                        <label className="font-medium">Input</label>
                        <div className="space-x-2">
                            <button onClick={encodeUrl} className="btn-primary">
                                Encode URL
                            </button>
                            <button onClick={encode} className="btn-primary">
                                Encode Component
                            </button>
                            <button onClick={decode} className="btn-primary">
                                Decode
                            </button>
                            <button onClick={clearAll} className="btn-secondary">
                                Clear
                            </button>
                        </div>
                    </div>
                    <textarea
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Enter URL or text to encode/decode..."
                        className="w-full h-32 p-4 border border-gray-300 rounded-lg font-mono text-sm"
                    />
                </div>

                {encoded && (
                    <div className="tool-card">
                        <div className="flex justify-between items-center mb-2">
                            <label className="font-medium">Encoded</label>
                            <button onClick={() => copyToClipboard(encoded)} className="btn-secondary">
                                Copy
                            </button>
                        </div>
                        <textarea
                            value={encoded}
                            readOnly
                            className="w-full h-32 p-4 border border-gray-300 rounded-lg font-mono text-sm bg-gray-50"
                        />
                    </div>
                )}

                {decoded && (
                    <div className="tool-card">
                        <div className="flex justify-between items-center mb-2">
                            <label className="font-medium">Decoded</label>
                            <button onClick={() => copyToClipboard(decoded)} className="btn-secondary">
                                Copy
                            </button>
                        </div>
                        <textarea
                            value={decoded}
                            readOnly
                            className="w-full h-32 p-4 border border-gray-300 rounded-lg font-mono text-sm bg-gray-50"
                        />
                    </div>
                )}
            </div>

            <div className="mt-8 bg-blue-50 border border-blue-200 rounded-lg p-4">
                <h3 className="font-semibold mb-2">💡 Difference</h3>
                <ul className="text-sm text-gray-700 space-y-1">
                    <li><strong>encodeURI:</strong> Encodes a full URI (doesn't encode: ; , / ? : @ & = + $ #)</li>
                    <li><strong>encodeURIComponent:</strong> Encodes URI component (encodes all special characters)</li>
                </ul>
                <p className="text-sm text-gray-700 mt-2">
                    Examples:
                </p>
                <ul className="text-sm font-mono text-gray-600 mt-1 space-y-1">
                    <li>Input: "hello world" → "hello%20world"</li>
                    <li>Input: "name=John&age=30" → "name%3DJohn%26age%3D30"</li>
                </ul>
            </div>
        </div>
    );
}
